import { useMemo } from 'react';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';
import { useAngularModalState } from '@web/common/hooks/useAngularModalState';
import { ShiftTasksBridgeState } from '@web/shiftTasks/ShiftTasksBridgeProvider/shiftTasksBridgeProvider.types';
import { ShiftTasksBridgeProvider } from '@web/shiftTasks/ShiftTasksBridgeProvider/ShiftTasksBridgeProvider';
import { TaskTemplate } from '@web/shiftTasks/types/TaskTemplate';

import { EditTaskTemplate } from './EditTaskTemplate';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  originalTemplate: any;
  shiftTasksReactBridge: ShiftTasksBridgeState;
};

export const EditTaskTemplateAngular = ({
  isOpen,
  onClose,
  shiftTasksReactBridge,
  originalTemplate,
}: Props) => {
  const template = useMemo(() => mapAngularTemplateToUI(originalTemplate), [originalTemplate]);
  const modalState = useAngularModalState(isOpen, onClose);

  // this should not be possible but since we don't have type check on angular side it's best to be safe
  if (!originalTemplate?.id) {
    return null;
  }

  return (
    <ShiftTasksBridgeProvider shiftTasksBridge={shiftTasksReactBridge}>
      <QueryClientProvider>
        {modalState.isVisible && (
          <EditTaskTemplate modalState={modalState} originalTemplate={template} />
        )}

        <ToastComponent />
      </QueryClientProvider>
    </ShiftTasksBridgeProvider>
  );
};

function mapAngularTemplateToUI(template: any): TaskTemplate {
  if (!template) {
    return null;
  }

  const { attachments = [], created, description, id, subtasks, title } = template;
  return {
    attachments,
    createdAt: new Date(created),
    description,
    id,
    subtasks: subtasks.map((s) => s.title),
    title,
  };
}
